interface TabPanelProps {
  children: React.ReactNode;
  value: number;
  index: number;
  className?: string;
}

export default function TabPanel({ children, value, index, className = '' }: TabPanelProps) {
  if (value !== index) return null;
  return (
    <div role="tabpanel" className={`pt-4 ${className}`}>
      {children}
    </div>
  );
}
